import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import PageHero from './PageHero';
import './css/AboutUsPage.css';
import aboutHeroImg from '../Assets/Image/aboutus.webp';
import { ShieldCheck, Compass, Target, Award } from 'lucide-react';
import SEO from './SEO';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const defaultContent = {
  heroTitle: 'About Us',
  heroImage: '',
  sectionTag: 'ABOUT WHALES ADVISORY',
  sectionTitle: 'Dedicated Legal Support\nAcross Egypt and the GCC',
  sectionDescription: '',
  sectionHighlight: '',
  cards: [],
};

const iconMap = {
  shieldCheck: ShieldCheck,
  compass: Compass,
  target: Target,
  award: Award,
};

const AboutUsPage = () => {
  const [content, setContent] = useState(defaultContent);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/about-us-page`);
        if (res.data && res.data.heroTitle !== undefined) {
          setContent({ ...defaultContent, ...res.data });
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchPage();
  }, []);

  const heroImagePath = content.heroImage
    ? content.heroImage.startsWith('http')
      ? content.heroImage
      : `${API_BASE_URL}${content.heroImage}`
    : aboutHeroImg;

  const titleLines = (content.sectionTitle || '').split('\n').filter(Boolean);

  const cards = Array.isArray(content.cards) ? content.cards : [];

  return (
    <div className="about-page-wrapper">
      <SEO
        title="About Us"
        description="Learn about Whales Advisory, our values, and our dedicated legal support across Egypt and the GCC."
        canonicalPath="/about"
        type="website"
      />
      <PageHero title={content.heroTitle} imagePath={heroImagePath} />

      <motion.section
        className="about-main-content"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
      >
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-section">
              <p className="section-tag">{content.sectionTag}</p>
              <h2 className="section-title">
                {titleLines.length > 0
                  ? titleLines.map((line, i) => (
                      <React.Fragment key={i}>
                        {i > 0 && <br />}
                        {line}
                      </React.Fragment>
                    ))
                  : content.sectionTitle}
              </h2>
              <p className="section-description">{content.sectionDescription}</p>
              <p className="section-highlight">{content.sectionHighlight}</p>
            </div>

            <div className="mission-vision-grid">
              {cards.map((card, i) => {
                const IconComponent = iconMap[card.iconKey] || ShieldCheck;
                const isFirst = i === 0;
                const isSecond = i === 1;
                const cardClass = isFirst
                  ? 'mission-vision-card mission-card'
                  : isSecond
                    ? 'mission-vision-card vision-card'
                    : 'mission-vision-card';
                return (
                  <div key={card.id || i} className={cardClass}>
                    <div className="mission-vision-icon">
                      <IconComponent size={48} strokeWidth={1.5} />
                    </div>
                    <h3 className="mission-vision-title">{card.title}</h3>
                    <p className="mission-vision-text">{card.text}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </motion.section>
    </div>
  );
};

export default AboutUsPage;
